import clsx from 'clsx';
import { CSSProperties } from 'react';
import useListItemStyles from './ListItem.styles';

interface Props {
	id: string;
	margin?: boolean;
	style?: CSSProperties;
	title: string;
	value: string | React.ReactElement;
	valueStyle?: CSSProperties;
}

const ListItem: React.FC<Props> = ({ id, margin, style, title, value, valueStyle }) => {
	const classes = useListItemStyles();

	return (
		<div
			className={clsx({
				[classes.margin]: margin,
			})}
			id={id}
			style={style}
		>
			<span className={classes.title} id={`${id}-title`}>
				{title}
			</span>
			{typeof value === 'string' ? (
				<span className={classes.value} id={`${id}-value`} style={valueStyle}>
					{value}
				</span>
			) : (
				value
			)}
		</div>
	);
};

export default ListItem;
